// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select {
  width: 230px;
  height: 38px;
  left: -30px;
}

select {
  width: 230px;
  height: 38px;
  outline: none;
  border: none;
  background: transparent;
  appearance: none;
}

.select-box {
  border: none;
  color: var(--black);
}

select:focus,
select:hover,
option:hover,
option:focus {
  outline: none;
  color: var(--black);
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/shared/dynamic-table/components/table-select/table-select.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EAIA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF;;AAEA;;;;EAIE,aAAA;EACA,mBAAA;EACA,UAAA;AACF","sourcesContent":[".select {\n  width: 230px;\n  height: 38px;\n  left: -30px;\n}\n\nselect {\n  width: 230px;\n  height: 38px;\n  outline: none;\n  border: none;\n  background: transparent;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n}\n\n.select-box {\n  border: none;\n  color: var(--black);\n}\n\nselect:focus,\nselect:hover,\noption:hover,\noption:focus {\n  outline: none;\n  color: var(--black);\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
